import { categories } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

export default function Categories() {
  return (
    <section id="categories" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="漫画分类"
        title="按类型发现好漫画"
        subtitle="热血、奇幻、校园、悬疑、治愈……总有一类戳中你的口味。点击进入对应分类，海量高分优质漫画任你挑选。"
      />

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {categories.map((cat) => (
          <a
            key={cat.name}
            href="#featured"
            className="group flex flex-col gap-3 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300 hover:bg-background-100 md:p-6"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 transition-colors group-hover:bg-secondary-500 group-hover:text-white md:h-14 md:w-14">
              <i className={`${cat.icon} text-xl md:text-2xl`} aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-lg text-foreground-950">{cat.name}</h3>
              <p className="mt-1 text-xs text-foreground-500">{cat.desc}</p>
              <p className="mt-2 inline-flex items-center gap-1 text-sm text-primary-600">
                {cat.count} 部作品
                <i
                  className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-1"
                  aria-hidden="true"
                ></i>
              </p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}